import { CanMatchFn, Route } from '@angular/router';
import { collectionFlowRoutes } from '@mzic/mzic-collection-flow';
import { mzicIoRoutes } from '@mzic/mzic-io';

const supportedLangs = new Set(['pt-br', 'en']);

const langCanMatch: CanMatchFn = (_route, segments) => {
  const lang = segments[0]?.path?.toLowerCase();
  return !!lang && supportedLangs.has(lang);
};

export const appRoutes: Route[] = [
  ...collectionFlowRoutes,
  {
    path: ':lang',
    canMatch: [langCanMatch],
    children: [...collectionFlowRoutes, ...mzicIoRoutes],
    title: (param) => {
      const lang = param.params['lang'];

      if (lang === 'pt-br') {
        return 'PARA ARTISTAS';
      }

      return 'FOR ARTISTS';
    },
  },
  {
    path: '',
    children: mzicIoRoutes,
    title: (param) => {
      const lang = param.params['lang'];

      if (lang === 'pt-br') {
        return 'PARA ARTISTAS';
      }

      return 'FOR ARTISTS';
    },
  },
];
